// extracted by mini-css-extract-plugin
module.exports = {"calendar":"UFOMonthFieldDialog_calendar__1UuRQ","visible":"UFOMonthFieldDialog_visible__1_eSi"};